import React, { useState } from "react";
import { useParams } from "react-router-dom";
import DetailSlider from "../../organisms/slider/DetailSlider";
import BookPackages from "./BookPackages";
import PackageDescription from "./PackageDescription";
import AboutPackages from "./AboutPackages";
import MorePackages from "./MorePackages";
import BookNowModal from "./BookNowModal";
import useGet from "../../customHooks/useGet/UseGet";
import VenorForm from "../../organisms/venorForm";
import VendorBookNowModal from "../../organisms/modals/VendorBookModal";

const PakagesDetail = () => {
  const [isBookModalShow, setIsBookModalShow] = useState(false);

  const { name } = useParams();
  const { data } = useGet(`list_packages`);

  const Item = data?.data?.find((item) => item.title === name);

  const handleBookModalChange = () => setIsBookModalShow(!isBookModalShow);
  return (
    <>
      {isBookModalShow && <BookNowModal isBookModalShow={true} />}
      <div className="my-4 px-5">
        <h2>{name} </h2>
      </div>

      <div className="border-top border-bottom px-5 d-flex py-3">
        <span>Detail</span>
        <span className="pl-4">Pakages</span>
      </div>
      <div className="my-4 px-5">
        <div className="row">
          <div className="col-md-8 col-sm-12 border-bottom">
            <DetailSlider
              data={Item?.images}
              feat={Boolean(Item?.is_featured)}
              exc={Boolean(Item?.is_exclusive)}
            />
            <div>
              <i className="fa fa-database" aria-hidden="true"></i> BD{" "}
              {Item?.price} pp
            </div>
          </div>
          <div className="col-md-4 d-none d-lg-block">
            <div className="card p-4">
              <VenorForm />
              {/* <BookPackages /> */}
            </div>
          </div>
        </div>
        <div className="d-sm-block d-md-block d-lg-none fixed-bottom card p-2">
          <div className="w-100 m-auto d-flex justify-content-center">
            <div>
              <button
                type="button"
                className="btn text-white bg-book-now"
                onClick={handleBookModalChange}
                data-toggle="modal"
                data-target="#BookNowModalBox"
              >
                Book Now
              </button>
              <VendorBookNowModal isBookModalShow={true} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-8">
            <PackageDescription Item={Item} />
            {/* <AboutPackages /> */}
            {/* <MorePackages data={data.data}/> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PakagesDetail;
